import React from 'react';
import PropTypes from 'prop-types';

import AddressAutoSuggest from './AddressAutoSuggest';
import FormikField from '../core/formik/FormikField';

const FormikAddressAutoSuggestField = ({ field, form, onSuggestionSelected, ...other }) => (
  <FormikField field={field} form={form}>
    <AddressAutoSuggest
      fieldValue={field.value}
      onSuggestionSelected={(_e, { suggestion }) => {
        form.setFieldValue(field.name, suggestion.fullAddress, true);
        if (onSuggestionSelected) {
          onSuggestionSelected(suggestion);
        }
      }}
      {...other}
    />
  </FormikField>
);

FormikAddressAutoSuggestField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldError: PropTypes.func,
    setFieldValue: PropTypes.func,
    setTouched: PropTypes.func,
  }).isRequired,
  onSuggestionSelected: PropTypes.func,
  other: PropTypes.object,
};

FormikAddressAutoSuggestField.defaultProps = {
  onSuggestionSelected: null,
  other: null,
};

export default FormikAddressAutoSuggestField;
